import { render } from "./AccountManagement.vue?vue&type=template&id=29808c1f&scoped=true&ts=true"
import script from "./AccountManagement.vue?vue&type=script&lang=ts"
export * from "./AccountManagement.vue?vue&type=script&lang=ts"

import "./AccountManagement.vue?vue&type=style&index=0&id=29808c1f&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\Administrator\\Documents\\Repos\\PROD-license-management\\redesign\\WebUI\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-29808c1f"]])

export default __exports__